@if (useStandardizedHeaderBar$ | async) {
  <div class="card card-pb-md mb-3">
    <ds-header-bar
      class="card-header"
      [title]="'organization_details_header' | translate"
      titleId="title"
      [chips]="wayfindingChips$ | async"
      [description]="'organization_details_header_description' | translate"
    >
    </ds-header-bar>
  </div>
  <div class="container-fluid">
    <div class="d-flex flex-column">
      <ng-container *ngTemplateOutlet="organizationDetailsTabs"></ng-container>
    </div>
  </div>
} @else {
  <div class="container-fluid">
    <div class="d-flex flex-column">
      <h1 id="title" data-test-id="title" class="mb-4">{{ 'organization_details_header' | translate }}</h1>
      <ng-container *ngTemplateOutlet="organizationDetailsTabs"></ng-container>
    </div>
  </div>
}

<ng-template #organizationDetailsTabs>
  @if (currentTenant()) {
    @if (isSelfManageOrgHierarchyEnabled()) {
      @if (isAdminView) {
        <ds-tabs
          [(activeId)]="activeTabId"
          (activeIdChange)="onTabChange($event)"
          tablistLabelledBy="title"
          data-test-id="org-level-tabs"
        >
          <ds-tab [label]="'management' | translate">
            <ng-container *ngTemplateOutlet="managementTabContent"></ng-container>
          </ds-tab>
          @if (hasAccessToAcademy() && isAcademyEnabled()) {
            <ds-tab [label]="'academy' | translate">
              <ng-container *ngTemplateOutlet="academyTabContent"></ng-container>
            </ds-tab>
          }
        </ds-tabs>
      } @else {
        <ng-container *ngTemplateOutlet="managementTabContent"></ng-container>
      }
    } @else {
      <ng-container *ngTemplateOutlet="organizationDetailsContent"></ng-container>
    }
  }
</ng-template>

<ng-template #academyTabContent>
  <app-tenant-tab-academy [tenant$]="currentTenantUnmapped$"></app-tenant-tab-academy>
</ng-template>

<ng-template #managementTabContent>
  <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
    <h2 class="mb-0">{{ 'management' | translate }}</h2>
    <div class="d-flex gap-4">
      <button
        *appHasPermissions="RequiredSecurities.Workspaces_Create"
        ds-button
        data-test-id="add-workspace-button"
        [variant]="DsButtonVariants.secondary"
        (click)="this.onCreateWorkspace()"
      >
        {{ 'add_workspace' | translate }}
      </button>
      <button
        *appHasPermissions="RequiredSecurities.Digital_Properties_Create"
        ds-button
        [variant]="DsButtonVariants.primary"
        data-test-id="add-digital-property-button"
        (click)="this.onCreateDigitalProperty()"
      >
        {{ 'label_add_digital_property' | translate }}
      </button>
    </div>
  </div>

  <app-userway-sso-error-banner
    [isVisible]="showUserWaySsoErrorBanner"
    (closed)="onUserWaySsoErrorBannerClosed()"
    data-test-id="error-userway-sso-banner"
  ></app-userway-sso-error-banner>

  <div class="row g-4">
    <ds-card class="col-12 col-lg-4" titleHeadingLevel="h3" [title]="'organization' | translate">
      <div ds-card-body>
        <ds-toggle
          class="mb-4"
          [label]="'display_archived_items' | translate"
          [labelPosition]="DsToggleLabelPosition.AFTER"
          [checked]="showArchivedItems()"
          (valueChange)="setShowArchivedItems($event)"
        ></ds-toggle>
        <ds-tree-menu
          [menuItems]="organizationTree()"
          [menuAriaLabel]="'all_workspaces_and_assets' | translate"
          [rootItemsAlwaysExpanded]="true"
        ></ds-tree-menu>
      </div>
    </ds-card>
    <ds-card
      #descriptionCard
      tabindex="-1"
      role="region"
      [attr.aria-label]="descriptionCardTitle()"
      class="col-12 col-lg-8"
      titleHeadingLevel="h3"
      [title]="descriptionCardTitle()"
      [showHeaderAction]="true"
    >
      @if (selectedItemType() !== SelectedTreeItemType.organization) {
        <div ds-card-header-action>
          @if (selectedItemType() === SelectedTreeItemType.workspace) {
            <ng-template [ngTemplateOutlet]="workspaceActions"></ng-template>
          } @else if (
            selectedItemType() === SelectedTreeItemType.website || selectedItemType() === SelectedTreeItemType.anotherAsset
          ) {
            <ng-template [ngTemplateOutlet]="assetActions"></ng-template>
          }
        </div>
      }

      <div ds-card-body>
        @if (selectedItemType() === SelectedTreeItemType.organization) {
          @if (isAtlasUserManagementEnabled()) {
            <span id="organization-details-tabs-label" class="visually-hidden" aria-hidden="true">
              {{ 'organization_details_header' | translate }}
            </span>
            <ds-tabs
              [(activeId)]="nodeDetailTabId"
              tablistLabelledBy="organization-details-tabs-label"
              data-test-id="organization-details-tabs"
            >
              <ds-tab [label]="'label_details' | translate">
                <ng-container *ngTemplateOutlet="organizationDetailsContent"></ng-container>
              </ds-tab>
              <ds-tab [label]="'users' | translate">
                <app-organization-users [tenantId]="tenantIdFromRoute()"></app-organization-users>
              </ds-tab>
            </ds-tabs>
          } @else {
            <ng-container *ngTemplateOutlet="organizationDetailsContent"></ng-container>
          }
        } @else if (selectedItemType() === SelectedTreeItemType.workspace) {
          @if (isAtlasUserManagementEnabled()) {
            <span id="workspace-details-tabs-label" class="visually-hidden" aria-hidden="true">
              {{ 'workspace_details_header' | translate }}
            </span>
            <ds-tabs
              [(activeId)]="nodeDetailTabId"
              tablistLabelledBy="workspace-details-tabs-label"
              data-test-id="workspace-details-tabs"
            >
              <ds-tab [label]="'label_details' | translate">
                <ng-container *ngTemplateOutlet="workspaceDetailsContent"></ng-container>
              </ds-tab>
              <ds-tab [label]="'users' | translate">
                <app-workspace-users
                  [tenantId]="tenantIdFromRoute()"
                  [workspaceId]="selectedWorkspace()?._id"
                ></app-workspace-users>
              </ds-tab>
            </ds-tabs>
          } @else {
            <ng-container *ngTemplateOutlet="workspaceDetailsContent"></ng-container>
          }
        } @else if (selectedItemType() === SelectedTreeItemType.website) {
          @if (isAtlasUserManagementEnabled()) {
            <span id="website-details-tabs-label" class="visually-hidden" aria-hidden="true">
              {{ 'digital_property_details_header' | translate }}
            </span>
            <ds-tabs
              [(activeId)]="nodeDetailTabId"
              tablistLabelledBy="website-details-tabs-label"
              data-test-id="website-details-tabs"
            >
              <ds-tab [label]="'label_details' | translate">
                <ng-container *ngTemplateOutlet="digitalPropertyDetailsWebsiteContent"></ng-container>
              </ds-tab>
              <ds-tab [label]="'users' | translate">
                <app-digital-property-users
                  [tenantId]="tenantIdFromRoute()"
                  [workspaceId]="selectedDigitalProperty()?.[$digitalProperty.workspaceId]"
                  [digitalPropertyId]="selectedDigitalProperty()?.[$digitalProperty._id]"
                ></app-digital-property-users>
              </ds-tab>
            </ds-tabs>
          } @else {
            <ng-container *ngTemplateOutlet="digitalPropertyDetailsWebsiteContent"></ng-container>
          }
        } @else {
          @if (isAtlasUserManagementEnabled()) {
            <span id="digital-asset-details-tabs-label" class="visually-hidden" aria-hidden="true">
              {{ 'digital_property_details_header' | translate }}
            </span>
            <ds-tabs
              [(activeId)]="nodeDetailTabId"
              tablistLabelledBy="digital-asset-details-tabs-label"
              data-test-id="digital-asset-details-tabs"
            >
              <ds-tab [label]="'label_details' | translate">
                <ng-container *ngTemplateOutlet="digitalPropertyDetailsContent"></ng-container>
              </ds-tab>
              <ds-tab [label]="'users' | translate">
                <app-digital-property-users
                  [tenantId]="tenantIdFromRoute()"
                  [workspaceId]="selectedDigitalProperty()?.[$digitalProperty.workspaceId]"
                  [digitalPropertyId]="selectedDigitalProperty()?.[$digitalProperty._id]"
                ></app-digital-property-users>
              </ds-tab>
            </ds-tabs>
          } @else {
            <ng-container *ngTemplateOutlet="digitalPropertyDetailsContent"></ng-container>
          }
        }
      </div>
    </ds-card>
  </div>
</ng-template>

<ng-template #workspaceActions>
  <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2">
    <button
      ds-button
      [variant]="DsButtonVariants.microAction"
      [microActionIcon]="Icons.Pencil"
      class="w-100 w-sm-auto"
      (click)="onEditWorkspace()"
      data-test-id="edit-workspace-button"
    >
      {{ 'edit_workspace' | translate }}
    </button>
    <ds-dropdown>
      <ds-dropdown-toggle
        [variant]="DsButtonVariants.microActionHorizontalLayout"
        [label]="'actions' | translate"
        [icon]="Icons.EllipsisVertical"
      ></ds-dropdown-toggle>
      <div ds-dropdown-menu>
        @if (selectedWorkspace()?.status === workspaceStatus.active) {
          <ds-dropdown-item
            [disabled]="!canArchiveWorkspace()"
            [label]="'label_archive' | translate"
            [icon]="Icons.TrashCan"
            (selected)="onChangeWorkspaceState(WorkspaceStateAction.archive)"
          >
          </ds-dropdown-item>
        } @else {
          <ds-dropdown-item
            data-test-id="restore-workspace-button"
            [label]="'label_restore' | translate"
            [icon]="Icons.ArrowsRotate"
            [disabled]="selectedWorkspace()?.status === workspaceStatus.closed"
            (selected)="onChangeWorkspaceState(WorkspaceStateAction.restore)"
          >
          </ds-dropdown-item>
        }
      </div>
    </ds-dropdown>
  </div>
</ng-template>

<ng-template #assetActions>
  <div class="d-flex flex-md-row flex-column align-items-center gap-2">
    @if (selectedDigitalProperty()?.status === DigitalPropertyStatus.active) {
      <button
        ds-button
        [variant]="DsButtonVariants.microAction"
        [microActionIcon]="Icons.Pencil"
        (click)="onEditDigitalProperty()"
        class="w-100"
      >
        {{ 'edit_asset' | translate }}
      </button>
    }
    <ds-dropdown>
      <ds-dropdown-toggle
        [variant]="DsButtonVariants.microActionHorizontalLayout"
        [label]="'actions' | translate"
        [icon]="Icons.EllipsisVertical"
      ></ds-dropdown-toggle>
      <div ds-dropdown-menu>
        <ds-dropdown-item
          [label]="'label_move' | translate"
          [icon]="Icons.ArrowsUpDownLeftRight"
          [disabled]="isMoveValidationInProgress() || availableDestinationWorkspaces().length === 0"
          (selected)="onMoveDigitalProperty()"
        ></ds-dropdown-item>
        @if (selectedDigitalProperty()?.status === DigitalPropertyStatus.active) {
          <ds-dropdown-item
            [label]="'label_archive' | translate"
            [icon]="Icons.TrashCan"
            (selected)="onChangeDigitalPropertyState(DigitalPropertyStateAction.archive)"
          ></ds-dropdown-item>
        } @else {
          <ds-dropdown-item
            [label]="'label_restore' | translate"
            [icon]="Icons.ArrowsRotate"
            (selected)="onChangeDigitalPropertyState(DigitalPropertyStateAction.restore)"
          ></ds-dropdown-item>
        }
      </div>
    </ds-dropdown>
  </div>
</ng-template>

<ng-template #organizationDetailsContent>
  <div class="d-flex flex-column gap-4">
    @if (!isSelfManageOrgHierarchyEnabled()) {
      <div class="d-flex flex-column gap-1">
        <strong data-test-id="manage-org-name">{{ 'label_tenant_name' | translate }}</strong>
        <div class="d-flex align-items-center gap-4" data-test-id="manage-org-name-value">
          {{ currentTenant().name }}
        </div>
      </div>
    }
    @if (descriptionFieldConfig(); as config) {
      <div class="d-flex flex-column gap-1">
        <strong data-test-id="manage-org-internal-notes">{{ config.label | translate }}</strong>
        <div class="d-flex align-items-center gap-4" data-test-id="manage-org-internal-notes-value">
          {{ config.field ?? '-' }}
        </div>
      </div>
    }
    <div class="d-flex flex-column gap-1">
      <strong data-test-id="manage-personalized-subdomain">{{ 'personalized_subdomain' | translate }}</strong>
      <div class="d-flex align-items-center gap-4 flex-wrap">
        <span id="manage-personalized-subdomain">{{ tenantUrl() }}</span>
        <ds-copy [htmlIdToCopy]="'manage-personalized-subdomain'"></ds-copy>
      </div>
    </div>

    <div [class]="isSelfManageOrgHierarchyEnabled() ? 'd-flex flex-column gap-4' : 'row g-4'">
      <ds-card
        [class]="isSelfManageOrgHierarchyEnabled() ? '' : 'col-12 col-lg-6'"
        [title]="currentTenant().packageName + ' ' + ('organization_label_package' | translate)"
        [titleHeadingLevel]="cardHeadingLevel"
      >
        <div ds-card-body class="d-flex flex-column gap-spacing-50">
          <strong data-test-id="org-usage-label">{{ 'organization_package_label_usage' | translate }}</strong>

          <div class="row row-cols-2 g-4">
            <div class="col">
              <strong class="d-block" data-test-id="org-digital-assets-label">
                {{ 'organization_package_label_digital_assets' | translate }}
              </strong>
              <span>{{ digitalAssetsUsage().count }} / {{ digitalAssetsUsage().limit }}</span>
            </div>
            <div class="col">
              <strong class="d-block" data-test-id="org-widgets-label">
                {{ 'organization_package_label_widgets_installed' | translate }}
              </strong>
              <span>{{ widgetsUsage().count }} / {{ widgetsUsage().limit }}</span>
            </div>
          </div>

          <div class="d-flex flex-column gap-1">
            <strong data-test-id="org-addons-label">{{ 'organization_package_label_addons' | translate }}</strong>
            <div>
              @if (currentTenant()?.packageAddons?.length) {
                @for (addon of currentTenant().packageAddons; track addon.id) {
                  <div>
                    <span>{{ addon.name }}</span>
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </ds-card>

      @if (isAiFeatureFlagEnabled()) {
        <ds-card
          [class]="isSelfManageOrgHierarchyEnabled() ? '' : 'col-12 col-lg-6'"
          [title]="'artificial_intelligence' | translate"
          [titleHeadingLevel]="cardHeadingLevel"
          [showHeaderAction]="true"
        >
          <div ds-card-header-action>
            <ds-chip
              data-test-id="org-ai-card-label"
              [text]="aiChipTextKey() | translate"
              [colorVariant]="DsChipColorVariant.Info"
              [size]="DsChipSize.Small"
            />
          </div>

          <div ds-card-body class="d-flex flex-column gap-spacing-50">
            <div data-test-id="org-ai-card-text">
              <strong>{{ 'organization_details_ai_features_text_bold' | translate }}</strong>
              {{ aiFeatureTextKey() | translate }}
            </div>

            <div class="mt-2">
              <button
                ds-button
                data-test-id="org-contact-support-label"
                [attr.aria-label]="'organization_details_contact_support' | translate"
                [variant]="DsButtonVariants.microAction"
                [microActionIcon]="Icons.ArrowUpRightFromSquare"
                (click)="onContactSupportClick($event)"
              >
                {{ 'organization_details_contact_support' | translate }}
              </button>
            </div>
          </div>
        </ds-card>
      }

      @if (isDigitalAssetsPrivacySettingEnabled()) {
        <ds-card
          [title]="'confidential_scanning' | translate"
          [titleHeadingLevel]="cardHeadingLevel"
          [showHeaderAction]="isConfidentialScanningEnabled()"
        >
          <div ds-card-header-action>
            <ds-chip
              data-test-id="org-confidential-scanning-enabled-chip"
              [text]="'enabled_for_all_digital_assets' | translate"
              [colorVariant]="DsChipColorVariant.LightBlue"
            />
          </div>

          <div ds-card-body class="d-flex flex-column gap-spacing-50">
            <div data-test-id="org-confidential-scanning-card-text">
              <strong>{{ 'confidential_scanning' | translate }}</strong>
              {{ confidentialFeatureTextKey() | translate }}
            </div>
          </div>
        </ds-card>
      }
    </div>
  </div>
</ng-template>

<ng-template #workspaceDetailsContent>
  <div class="d-flex flex-column gap-4">
    <div class="d-flex flex-column gap-1">
      <strong data-test-id="manage-org-description">{{ 'label_workspace_description' | translate }}</strong>
      <div class="d-flex align-items-center gap-4">
        {{ selectedWorkspace()?.description ?? '-' }}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #digitalPropertyDetailsWebsiteContent>
  <div class="d-flex flex-column gap-4">
    <div class="row g-4">
      <div class="col-12 col-lg-6">
        <div class="d-flex flex-column gap-2">
          <strong class="d-block" data-test-id="manage-digital-asset-url-label">
            {{ 'label_url' | translate }}
          </strong>
          <a class="text-break" href="{{ selectedDigitalProperty()?.url }}">{{ selectedDigitalProperty()?.url }}</a>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="d-flex flex-column gap-2">
          <strong class="d-block" data-test-id="manage-default-testing-tool-label">
            {{ 'digital_default_tool_label' | translate }}
          </strong>
          <div class="text-break">
            {{ selectedDigitalProperty()?.defaultTool }}
          </div>
        </div>
      </div>
    </div>

    <div class="row g-4">
      <div class="col-12 col-lg-6">
        <div class="d-flex flex-column gap-2">
          <strong class="d-block" data-test-id="manage-digital-asset-key-label">
            {{ 'digital_property_key_label' | translate }}
          </strong>
          <div class="text-break">
            {{ selectedDigitalProperty()?.propertyKey }}
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6">
        <div class="d-flex flex-column">
          <strong class="d-block" data-test-id="manage-widget-status-label">{{ 'widget' | translate }}</strong>
          <div class="d-flex flex-row align-items-center flex-wrap gap-2">
            <span>{{ userWayWidgetEnabled() ? ('widget_enabled' | translate) : ('widget_not_installed' | translate) }}</span>
            @if (userWayWidgetEnabled()) {
              <button
                ds-button
                role="link"
                class="flex-box flex-row-reverse gap-2"
                [variant]="DsButtonVariants.microActionHorizontalLayout"
                [microActionIcon]="Icons.ArrowUpRightFromSquare"
                [ds-tooltip]="'open_widget_configuration' | translate"
                (click)="onConfigureWidgetClicked()"
                (keydown.space)="$event.preventDefault()"
              >
                <span data-test-id="configure-widget-button">{{ 'configure_widget_label' | translate }}</span>
                <span class="ds-visually-hidden">{{ 'opens_in_new_tab_label' | translate }}</span>
              </button>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="row g-4">
      <div class="col-12 col-lg-6">
        <div class="d-flex flex-column">
          <strong class="d-block" data-test-id="manage-accessibility-statement-label">{{
            'accessibility_statement' | translate
          }}</strong>
          <div class="d-flex flex-row align-items-center flex-wrap gap-2">
            <span>{{ (selectedDigitalProperty()?.accessibilityStatement ? 'yes' : 'no') | translate }}</span>
            @if (selectedDigitalProperty()?.accessibilityStatement) {
              <button
                ds-button
                role="link"
                class="flex-box flex-row-reverse gap-2"
                [variant]="DsButtonVariants.microActionHorizontalLayout"
                [microActionIcon]="Icons.ArrowUpRightFromSquare"
                [ds-tooltip]="'view_accessibility_statement' | translate"
                (click)="onOpenStatementClicked()"
                (keydown.space)="$event.preventDefault()"
              >
                <span data-test-id="open-statement-button">{{ 'view_statement' | translate }}</span>
                <span class="ds-visually-hidden">{{ 'opens_in_new_tab_label' | translate }}</span>
              </button>
            }
          </div>
        </div>
      </div>

      @if (isScanningAgentEnabled()) {
        <div class="col-12 col-lg-6">
          <div class="d-flex flex-column gap-2">
            <strong class="d-block" data-test-id="manage-scanning-agent-label">{{ 'scanning_agent' | translate }}</strong>
            <div>
              {{ (selectedDigitalProperty()?.useScanningAgent ? 'label_on' : 'label_off') | translate }}
            </div>
          </div>
        </div>
      }
    </div>

    <div class="d-flex flex-column gap-2">
      <strong class="d-block" data-test-id="manage-asset-tags-label">{{ 'tags' | translate }}</strong>
      <div class="d-flex flex-row flex-wrap gap-2">
        @if ((selectedDigitalProperty()?.tags ?? []).length === 0) {
          <span>-</span>
        } @else {
          @for (tag of selectedDigitalProperty()?.tags ?? []; track tag) {
            <ds-chip [text]="tag" [colorVariant]="DsChipColorVariant.LightBlue" />
          }
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #digitalPropertyDetailsContent>
  <div class="d-flex flex-column gap-4">
    <div class="d-flex flex-column gap-1">
      <strong data-test-id="manage-digital-asset-key-label">{{ 'digital_property_key_label' | translate }}</strong>
      <div class="d-flex align-items-center gap-4">
        {{ selectedDigitalProperty()?.propertyKey }}
      </div>
    </div>

    <div class="d-flex flex-column gap-2">
      <strong data-test-id="manage-asset-tags-label">{{ 'tags' | translate }}</strong>
      <div class="d-flex flex-row flex-wrap gap-2 mt-2">
        @if ((selectedDigitalProperty()?.tags ?? []).length === 0) {
          -
        } @else {
          @for (tag of selectedDigitalProperty()?.tags ?? []; track tag) {
            <ds-chip [text]="tag" [colorVariant]="DsChipColorVariant.LightBlue" />
          }
        }
      </div>
    </div>
  </div>
</ng-template>
